<template>
    <section class="worldcup-slots">
        <b-container>
            <div class="worldcup-slots__box">
                <div class="worldcup-slots__banner">
                    <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-slots/banner-slots-worldcup.png`" alt="banner">
                </div>
                <div class="worldcup-slots__content">
                    <div class="title">HỐT THƯỞNG TO - SĂN SIÊU HŨ</div>
                    <div class="slots-tabs">
                        <b-tabs class="slots-tabs__tabs">
                            <template v-for="(tab, index) in tabs">
                                <b-tab :key="index"
                                       lazy
                                       pills
                                       :active="tab.isActive"
                                       :disabled="tab.isRequiredLogin && !currentUser">
                                    <template #title>
                                        <span>{{ tab.title }}</span>
                                    </template>
                                    <component :is="tab.component" />
                                </b-tab>
                            </template>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </b-container>
    </section>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import TopRancing from '~/components/event/worldcup/top-rancing.vue';
// eslint-disable-next-line import/no-unresolved
import DailyWinner from '~/components/event/worldcup/daily-winner.vue';

export default {
    data() {
        return {
            tabs: [
                {
                    title: 'ĐUA TOP- săn hũ',
                    isActive: true,
                    component: TopRancing
                },
                {
                    title: 'DAILY WINNER',
                    isActive: false,
                    component: DailyWinner
                }
            ]
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        }
    }
};
</script>
